function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L54 0L54 57L0 57L0 0Z",
  id: "angular_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "angular_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#angular_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "angularjs-for-header-only-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L54 0L54 57L0 57L0 0Z",
  id: "angularjs-for-header-only-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#angular_mask_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 9.42443L4.25039 44.5102L26.9271 56.9187L49.7207 44.3418L53.9697 9.25732L26.8985 0L0 9.42443Z",
  id: "Vector",
  fill: "#E2E2E2",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0L0 50.97L20.491 39.6798L24.4509 8.30127L0 0Z",
  transform: "translate(26.835938 2.984375)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.64207 39.8307L23.8169 50.971L23.8169 0L0 8.45187L3.64207 39.8307Z",
  transform: "translate(3.0185547 2.9833984)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.6756 11.8103L11.7255 23.5008L22.2988 23.5008L16.6756 11.8103ZM9.53718 28.4168L6.20252 36.7206L0 36.8346L16.6314 0L33.8424 36.8343L28.0933 36.8343L24.4425 28.4168L9.53718 28.4168Z",
  transform: "translate(10.204102 4.834961)",
  id: "Vector",
  fill: "#141335",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.0445666 11.8103L5.66187 23.5099L0.0126847 23.5099L0 28.409L7.81113 28.4164L11.462 36.8356L17.3971 36.9454L0.000325122 0L0.0445666 11.8103Z",
  transform: "translate(26.835938 4.834961)",
  id: "Vector",
  fill: "#131334",
  fillRule: "evenodd",
  stroke: "none"
})));

var SvgAngularjs = function SvgAngularjs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "57px",
    viewBox: "0 0 54 57",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAngularjs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/angularjs.fc385b86.svg";
export { ForwardRef as ReactComponent };